import styled, { css } from 'styled-components';
import { getSchemaVariant } from '../../../foundation/theme/palette.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { AVATAR_SIZE_MAP } from './Avatar.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const AvatarRoot = styled.div `
  ${({ mode, schema, size, showDot, theme, variant, color }) => {
    const { default: normal } = getSchemaVariant({
        mode,
        schema,
        theme,
        variant
    });
    const pixels = AVATAR_SIZE_MAP[size];
    return css `
      display: inline-block;
      position: relative;

      img {
        border-radius: 50%;
        max-height: ${pixels}px;
        max-width: ${pixels}px;
        height: ${pixels}px;
        vertical-align: top;
        width: ${pixels}px;
      }

      .avatar-icon,
      .avatar-text {
        align-items: center;
        background-color: ${color || normal.background};
        border-radius: 50%;
        color: ${color ? '#fff' : normal.foreground};
        display: inline-flex;
        height: ${pixels}px;
        justify-content: center;
        max-height: ${pixels}px;
        max-width: ${pixels}px;
        width: ${pixels}px;
      }

      ${showDot &&
        `
        &::after {
          background-color: ${tokens.colors.green[500].value};
          border-radius: 50%;
          top: 14.8%;
          content: '';
          display: block;
          height: 10px;
          position: absolute;
          right: 14.8%;
          transform: translate(5px, -5px);
          width: 10px;
        }
      `}
    `;
}}
`;
export const AvatarText = styled.div `
  background-color: red;
`;
//# sourceMappingURL=Avatar.styled.js.map